import { render, staticRenderFns } from "./LoanOnboardingStepPage.vue?vue&type=template&id=c4cf77d0&"
import script from "./LoanOnboardingStepPage.vue?vue&type=script&lang=js&"
export * from "./LoanOnboardingStepPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports